import { User } from "../../../../types/User";
import React from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import CopyToClipboard from '../../CopyToClipboard';
import UserActions from '../UserActions';
import { Button } from '@mui/material';
import { CheckIcon, HourglassBottomIcon, DeleteIcon, AddIcon, RemoveIcon } from "../../../../globals/icons";
import { useModal } from "../../../../contexts/Modal";
import { deleteUser } from "../../../../api/users";
import BasicSelect from '../../Select';

interface UserRowProps {
    row: User,
    setUsersList: React.Dispatch<React.SetStateAction<User[] | []>>;
}
const UserRow: React.FC<UserRowProps> = ({ row, setUsersList }) => {
    const { setModalStatus } = useModal();

    const displayStatus = (status: "confirmed" | "unconfirmed") => {
        if (status === "confirmed") {
            return (
                <Button startIcon={<CheckIcon />} variant="outlined" size="small" color="success">
                    {status}
                </Button>
            )
        }
        return (
            <Button startIcon={<HourglassBottomIcon />} variant="outlined" size="small" color="warning">
                {status}
            </Button>
        )
    }

    return (
        <TableRow
            hover
            role="checkbox"
            tabIndex={-1}
            key={row.user_id}
            sx={{ cursor: 'pointer' }}
        >
            <TableCell
                component="th"
                id={`enhanced-table-checkbox-${row.user_id}`}
                scope="row"
                padding="none"
                align="center"
            >
                <CopyToClipboard
                    textToCopy={row.user_id.toString()}
                    tooltipCopy="Copy User ID"
                    tooltipCopied="User ID Copied!"
                />
            </TableCell>
            <TableCell align="center">
                {row.first_name} {row.last_name}
            </TableCell>
            <TableCell align="center">{row.username}</TableCell>
            <TableCell align="center">{row.company}</TableCell>
            <TableCell align="center">{displayStatus(row.user_status)}</TableCell>
            <TableCell align="center"><BasicSelect user={row} /></TableCell>
            <TableCell align="center"><Button startIcon={<DeleteIcon />} onClick={() => setModalStatus({
                type: 'delete',
                validateAction: () => {
                    deleteUser(row.user_id.toString()).then(() => {
                        setUsersList((prevUsers) => prevUsers.filter((user) => user.user_id !== row.user_id));
                        console.log(`User with ID: ${row.user_id} deleted successfully.`);
                        setModalStatus({ type: null, validateAction: null });
                    }).catch((error) => {
                        console.error(`Error deleting user with ID: ${row.user_id}`, error);
                    });
                }
            })} variant='outlined' color='error' fullWidth>Delete User</Button></TableCell>
        </TableRow>
    );
}

export default UserRow;